export default {
  'engagement_active_title': 'Active',

  'engagement_active_activeUsers_tab': 'Active Users',
  'engagement_active_onlineAnalysis_tab': 'Playtime Analysis',
  'engagement_active_activeDegree_tab': 'Active Degree',
  'engagement_active_activeUsers_date': 'Date',
  // au
  'engagement_active_activeUsers_day_au_title': 'DAU',
  'engagement_active_activeUsers_day_au_legend1': 'Today',
  'engagement_active_activeUsers_day_au_legend2': 'Same Day Last Week',
  'engagement_active_activeUsers_day_au_legend3': 'SDLW',
  'engagement_active_activeUsers_week_au_title': 'WAU',
  'engagement_active_activeUsers_week_au_legend1': 'This week',
  'engagement_active_activeUsers_week_au_legend2': 'Same Week Last Month',
  'engagement_active_activeUsers_week_au_legend3': 'SWLM',
  'engagement_active_activeUsers_month_au_title': 'MAU',
  'engagement_active_activeUsers_month_au_legend1': 'This Month',
  'engagement_active_activeUsers_month_au_legend2': 'Same Month Last Year',
  'engagement_active_activeUsers_month_au_legend3': 'SMLY',
  // pcu and acu
  'engagement_active_activeUsers_pcu_acu_title': 'PCU and ACU',
  'engagement_active_activeUsers_pcu_acu_legend1': 'PCU',
  'engagement_active_activeUsers_pcu_acu_legend2': 'ACU',
  // dau breakdown
  'engagement_active_activeUsers_day_au_breakdown_title': 'DAU Breakdown',
  'engagement_active_activeUsers_day_au_breakdown_sum_row': 'DAU',
  'engagement_active_activeUsers_day_au_breakdown_legend1': 'DAU',
  'engagement_active_activeUsers_day_au_breakdown_legend2': 'New Users',
  'engagement_active_activeUsers_day_au_breakdown_legend3': 'Retention Users',
  'engagement_active_activeUsers_day_au_breakdown_legend4': 'Return Users',
  // dau channel distribution
  'engagement_active_activeUsers_day_channel_distribution_title': 'DAU Channel Distribution',
  'engagement_active_activeUsers_week_channel_distribution_title': 'WAU Channel Distribution',
  'engagement_active_activeUsers_month_channel_distribution_title': 'MAU Channel Distribution',
  // dau platform distribution
  'engagement_active_activeUsers_day_platform_distribution_title': 'DAU Platform Distribution',
  'engagement_active_activeUsers_week_platform_distribution_title': 'WAU Platform Distribution',
  'engagement_active_activeUsers_month_platform_distribution_title': 'MAU Platform Distribution',
  // breakdown
  'engagement_active_activeUsers_breakdown_title': 'Country/Region/Zone Breakdown',
  'engagement_active_activeUsers_breakdown_country': 'Country',
  'engagement_active_activeUsers_breakdown_region': 'Region',
  'engagement_active_activeUsers_breakdown_zone': 'Zone',
  'engagement_active_activeUsers_breakdown_country_name': 'Countries',
  'engagement_active_activeUsers_breakdown_region_name': 'Regions',
  'engagement_active_activeUsers_breakdown_zone_name': 'Zones',
  'engagement_active_activeUsers_breakdown_day_chart_title': 'DAU of Top 10 ',
  'engagement_active_activeUsers_breakdown_week_chart_title': 'WAU of Top 10 ',
  'engagement_active_activeUsers_breakdown_month_chart_title': 'MAU of Top 10 ',
  'engagement_active_activeUsers_breakdown_day_au_avg': 'Avg.DAU',
  'engagement_active_activeUsers_breakdown_week_au_avg': 'Avg.WAU',
  'engagement_active_activeUsers_breakdown_month_au_avg': 'Avg.MAU',
  'engagement_active_activeUsers_breakdown_day_au': 'DAU',
  'engagement_active_activeUsers_breakdown_week_au': 'WAU',
  'engagement_active_activeUsers_breakdown_month_au': 'MAU',
  'engagement_active_activeUsers_breakdown_share': 'Share of All',
  'engagement_active_activeUsers_breakdown_share_table': 'Share',
  'engagement_active_activeUsers_breakdown_date': 'Date',
  // distribution
  'engagement_active_activeUsers_distribution_title': 'AU Level Distribution',
  'engagement_active_activeUsers_distribution_chart_title': 'Active Users',
  'engagement_active_activeUsers_distribution_date': 'Date',
  'engagement_active_activeUsers_distribution_day_name': 'D',
  'engagement_active_activeUsers_distribution_week_name': 'W',
  'engagement_active_activeUsers_distribution_month_name': 'M',
  'engagement_active_activeUsers_distribution_tab1': 'Accumulated',
  'engagement_active_activeUsers_distribution_tab2': 'Top 10 Level',
  // role
  'engagement_active_activeUsers_role_count_title': 'Active Role Count',
  'engagement_active_activeUsers_role_date': 'Date',

  'engagement_active_activeUsers_role_count_chart_title': 'Active Roles',
  'engagement_active_activeUsers_role_count_day_legend1': 'Today',
  'engagement_active_activeUsers_role_count_day_legend2': 'Same Day Last Week',
  'engagement_active_activeUsers_role_count_day_legend3': 'SDLW',
  'engagement_active_activeUsers_role_count_week_legend1': 'This Week',
  'engagement_active_activeUsers_role_count_week_legend2': 'Same Week Last Month',
  'engagement_active_activeUsers_role_count_week_legend3': 'SWLM',
  'engagement_active_activeUsers_role_count_month_legend1': 'This Month',
  'engagement_active_activeUsers_role_count_month_legend2': 'Same Month Last Year',
  'engagement_active_activeUsers_role_count_month_legend3': 'SMLY',
  
  'engagement_active_activeUsers_role_count_distribution_title': 'Active Role Count Distribution',
  'engagement_active_activeUsers_role_count_distribution_chart_title': 'Active Users',
  'engagement_active_activeUsers_role_count_distribution_legend1': '1 Role',
  'engagement_active_activeUsers_role_count_distribution_legend2': '2 Roles',
  'engagement_active_activeUsers_role_count_distribution_legend3': '3 Roles',
  'engagement_active_activeUsers_role_count_distribution_legend4': '4 Roles',
  'engagement_active_activeUsers_role_count_distribution_legend5': '5+ Roles',
  // online analysis
  'engagement_active_online_avg_time_date': 'Date',
  'engagement_active_online_avg_time_title': 'Average Playtime',
  'engagement_active_online_avg_time_legend1': 'Average Playtime (min)',
  'engagement_active_online_avg_time_legend2': 'Average session length (min)',
  // online overall online time
  'engagement_active_online_overall_date': 'Date',
  'engagement_active_online_overall_title': 'Overall Playtime',
  'engagement_active_online_overall_dau': 'DAU',
  'engagement_active_online_overall_total': 'Total duration of all sessions(min)',
  'engagement_active_online_overall_avg_online_time': 'Average Playtime(min)',
  'engagement_active_online_overall_login_count': 'Sessions',
  'engagement_active_online_overall_avg_online_time_per_login': 'Average session length(min)',
  // online time distribution
  'engagement_active_online_distribution_title': 'Playtime Distribution',
  'engagement_active_online_distribution_date': 'Date',
  // online Average Online Time By Level
  'engagement_active_online_level_title': 'Average Playtime By Level',
  'engagement_active_online_level_date': 'Date',
  // active degree
  'engagement_active_degree_weekly_activity_title': 'Weekly Active Users Activity',
  'engagement_active_degree_weekly_activity_chart_title': 'Login {day} Active Users',
  'engagement_active_degree_weekly_activity_legend1': 'This Week',
  'engagement_active_degree_weekly_activity_legend2': 'Last Week',
  'engagement_active_degree_weekly_activity_legend3': 'Avg. All Weeks',
  'engagement_active_degree_weekly_activity_day': '{day}{unit}',
  'engagement_active_degree_weekly_activity_date': 'Day',

  'engagement_active_degree_weekly_days_title': 'Weekly Active Days',
  'engagement_active_degree_weekly_days_chart_title': 'Login {day} Active Users',
  'engagement_active_degree_weekly_days_date': 'Day',
  'engagement_active_degree_weekly_days_login_au': 'Login days Active Users',
  'engagement_active_degree_weekly_days_legend1': '1day',
  'engagement_active_degree_weekly_days_legend2': '2days',
  'engagement_active_degree_weekly_days_legend3': '3days',
  'engagement_active_degree_weekly_days_legend4': '4days',
  'engagement_active_degree_weekly_days_legend5': '5days',
  'engagement_active_degree_weekly_days_legend6': '6days',
  'engagement_active_degree_weekly_days_legend7': '7days',
  'engagement_active_degree_biweekly_activity_title': 'Biweekly Active Users Activity',
  'engagement_active_degree_biweekly_activity_chart_title': 'Login {day}',
  'engagement_active_degree_biweekly_activity_legend1': 'Biweekly Active Users',
  'engagement_active_degree_biweekly_activity_day': '{day}{unit}',
  'engagement_active_degree_biweekly_activity_date': 'Day',

  'engagement_active_activeUsers_week_au_breakdown_title': 'WAU Breakdown',
  
  'engagement_active_activeUsers_week_au_breakdown_sum_row': 'WAU',
  'engagement_active_activeUsers_week_au_breakdown_legend1': 'WAU',
  'engagement_active_activeUsers_week_au_breakdown_legend2': 'New Users',
  'engagement_active_activeUsers_week_au_breakdown_legend3': 'Retention Users',
  'engagement_active_activeUsers_week_au_breakdown_legend4': 'Return Users',

  'engagement_active_activeUsers_month_au_breakdown_sum_row': 'MAU',
  'engagement_active_activeUsers_month_au_breakdown_legend1': 'MAU',
  'engagement_active_activeUsers_month_au_breakdown_legend2': 'New Users',
  'engagement_active_activeUsers_month_au_breakdown_legend3': 'Retention Users',
  'engagement_active_activeUsers_month_au_breakdown_legend4': 'Return Users',

  'engagement_active_activeUsers_month_au_breakdown_title': 'MAU Breakdown',

  'engagement_active_activeUsers_breakdown_dau': 'DAU',
  'engagement_active_activeUsers_breakdown_wau': 'WAU',
  'engagement_active_activeUsers_breakdown_mau': 'MAU',

  'engagement_active_activeUsers_dau_of_top_10_countries': 'DAU of Top 10 Countries',
  'engagement_active_activeUsers_wau_of_top_10_countries': 'WAU of Top 10 Countries',
  'engagement_active_activeUsers_mau_of_top_10_countries': 'MAU of Top 10 Countries',

  'engagement_active_activeUsers_dau_of_top_10_regions': 'DAU of Top 10 Countries',
  'engagement_active_activeUsers_wau_of_top_10_regions': 'WAU of Top 10 Regions',
  'engagement_active_activeUsers_mau_of_top_10_regions': 'MAU of Top 10 Regions',

  'engagement_active_activeUsers_dau_of_top_10_zones': 'DAU of Top 10 Zones',
  'engagement_active_activeUsers_wau_of_top_10_zones': 'WAU of Top 10 Zones',
  'engagement_active_activeUsers_mau_of_top_10_zones': 'MAU of Top 10 Zones',



  'engagement_active_degree_biweekly_days_title': 'Biweekly Active Days',
  'engagement_active_degree_biweekly_days_chart_title': 'Login {day} Active Users',
  'engagement_active_degree_biweekly_days_login_au': 'Login days Active Users',
  'engagement_active_degree_biweekly_days_date': 'Day',

  'engagement_active_degree_monthly_day': '{day}{unit}',
  'engagement_active_degree_monthly_date': 'Day',
  'engagement_active_degree_monthly_activity_title': 'Monthly Active Users Activity',
  'engagement_active_degree_monthly_activity_legend1': 'This Month',
  'engagement_active_degree_monthly_activity_legend2': 'Last Month',
  'engagement_active_degree_monthly_days_title': 'Monthly Active Days',
  'engagement_active_degree_monthly_activity_chart_title': 'Login {day} Active Users',
  'engagement_active_degree_monthly_days_chart_title': 'Login {day} Active Users',
  'engagement_active_degree_monthly_days_login_au': 'Login days Active Users',

  // 为卡片 " Active User Trend Analysis 活跃用户趋势分析 " 准备
  'engagement_active_degree_active_user_trend_analysis_hover1': 'High Active',
  'engagement_active_degree_active_user_trend_analysis_hover2': 'Medium Active',
  'engagement_active_degree_active_user_trend_analysis_hover3': 'Low Active',
  'engagement_active_degree_active_user_trend_analysis_legend1': 'High Active (6~7 Days)',
  'engagement_active_degree_active_user_trend_analysis_legend2': 'Medium Active (3~5 Days)',
  'engagement_active_degree_active_user_trend_analysis_legend3': 'Low Active (1~2 Days)',
  'engagement_active_degree_active_user_trend_analysis_date': 'Date',

  // 为卡片 " Weekly Active User Trend Analysis 活跃用户周趋势分析 " 准备
  'engagement_active_degree_weekly_active_user_trend_analysis_hover1': 'High Active',
  'engagement_active_degree_weekly_active_user_trend_analysis_hover2': 'Medium Active',
  'engagement_active_degree_weekly_active_user_trend_analysis_hover3': 'Low Active',
  'engagement_active_degree_weekly_active_user_trend_analysis_legend1': 'High Active (6~7 Days)',
  'engagement_active_degree_weekly_active_user_trend_analysis_legend2': 'Medium Active (3~5 Days)',
  'engagement_active_degree_weekly_active_user_trend_analysis_legend3': 'Low Active (1~2 Days)',
  'engagement_active_degree_weekly_active_user_trend_analysis_date': 'Date',
}
